module.exports = "TOTAL"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/common/view-balances-popup/view-balances-cell-renderer/view-balances-cell-renderer.component.html
// module id = ../../../../../src/app/shared/components/common/view-balances-popup/view-balances-cell-renderer/view-balances-cell-renderer.component.html
// module chunks = main